module.exports = __webpack_public_path__ + "img/msbr-284.prt.063016d8.jpg";